export const NegativeFeedbackOptions = [
  "No me gusta el estilo",
  "Los hechos no son correctos",
  "No cumplió completamente con las instrucciones",
];
